<template>
  <anchor-modal
    light
    header-color="white"
    body-classes="ma-0 pa-0"
    :max-width="maxWidth"
    :title="title"
    :value="value"
    :loading="loading"
    @input="val => $emit('input', val)"
  >
    <v-divider />

    <checklist-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :sort-by="sortBy"
      :item-key="itemKey"
      :status-map="statusMap"
      @row-clicked="item => $emit('row-clicked', item)"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope"/>
      </template>
    </checklist-table>

    <v-divider />

    <template v-slot:bottom-actions v-if="!hideActions">
      <v-spacer />
      <v-btn small class="my-4 mx-2" @click="$emit('input', false)">
        Close
      </v-btn>
      <v-btn small class="my-4 mx-2" color="primary" @click="$emit('update-docs')">
        Update Docs
      </v-btn>
    </template>
  </anchor-modal>
</template>

<script>
import CHECKLIST_HEADERS from '../../../resources/js/checklist/headers';
import ChecklistTable from './ChecklistTable';

export default {
  name: 'AnchorChecklistModal',
  components: {
    ChecklistTable,
  },
  props: {
    hideActions: Boolean,
    maxWidth: {
      type: [String, Number],
      default: 1000,
    },
    title: {
      type: String,
      default: 'Checklist',
    },
    items: Array,
    headers: {
      type: Array,
      default: () => CHECKLIST_HEADERS,
    },
    loading: Boolean,
    sortBy: Array,
    itemKey: String,
    statusMap: Object,
    value: undefined,
  },
};
</script>
